
import { userProfile } from '@/services/user'
import { auth } from '@/services/firebase'

export default {
  name: 'UserInfo',
  setup() {
    const onLogoutClick = function() {
      auth.signOut()
    }
    return { onLogoutClick, userProfile }
  }
}
